import Dashboard from "../components/dashboard";
import DashboardIcon from "./icons/DashboardIcon";

const dashboardRoute = [
  {
    // path: "dashboard",
    // element: <Dashboard />,
    // index: 0,
    // name: "Dashboard",
    // link: "dashboard",
    // icon: DashboardIcon,
  },
];
export default dashboardRoute;
